import type { ReactNode } from 'react';

import css from './styles.module.css';

export function SheetHandle(): ReactNode {
	return <div aria-hidden="true" className={css.handle} />;
}
